import { render } from "./PermitLookupResult.vue?vue&type=template&id=26de4bc4"
import script from "./PermitLookupResult.vue?vue&type=script&lang=ts"
export * from "./PermitLookupResult.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./PermitLookupResult.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script